'use client'

import { IBasicUser, IFormValues } from '@repo/sdk'
import { useEffect, useState } from 'react'
import { ControllerRenderProps } from 'react-hook-form'
import ReactPhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

export const PhoneInput = (
  field:
    | ControllerRenderProps<IBasicUser, 'phone'>
    | ControllerRenderProps<IFormValues, 'account.phone'>,
) => {
  const [country, setCountry] = useState<string>('')

  useEffect(() => {
    if (field.value === undefined) return
    if (field.value === null) {
      if (process.env.NEXT_PUBLIC_SOURCE === 'kcharles') setCountry('gb')
    }
  }, [field.value])

  return (
    <ReactPhoneInput
      country={country}
      enableAreaCodes={true}
      specialLabel=" "
      {...field}
      buttonClass="!bg-gray-100 !bg-background dark:!bg-background hover:!bg-background dark:!text-neutral-300 dark:!border-slate-700"
      containerClass="!border-gray-700"
      dropdownClass="!bg-background top-[82%]"
      inputClass="!h-10 !w-full !bg-background focus:!ring-[hsl(0,0%,7%)] focus:!ring-2 !rounded-md shadow-none focus-visible:ring-2 dark:!border-slate-700 dark:!bg-background dark:!text-neutral-300"
    />
  )
}
